// extracted by mini-css-extract-plugin
export default {"agent-content":"AgentContent_agent-content__WbG4n"};